// extracted by css-extract-rspack-plugin
export default {"container":"uhZRetZXEgmpJcwV"};